import { render } from "./doctorNavbar.vue?vue&type=template&id=56adc088&scoped=true"
import script from "./doctorNavbar.vue?vue&type=script&lang=js"
export * from "./doctorNavbar.vue?vue&type=script&lang=js"

import "./doctorNavbar.vue?vue&type=style&index=0&id=56adc088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56adc088"]])

export default __exports__